import { useBlockProps } from '@wordpress/block-editor';
import { ultimateIcons } from './icons';
import Style from './Style';

export default function save( { attributes } ) {
	const { blockId } = attributes;
	const blockProps = useBlockProps.save( {
		className: `alpha-icon-block-${ blockId }`,
	} );
	const { icon } = attributes;

	const iconNameToSVG = ( iconName ) => {
		const iconData = ultimateIcons
			.map( ( types ) => types.icons )
			.flat()
			.find( ( ic ) => ic.name === iconName );
		return iconData ? iconData.icon : null;
	};

	const IconComponent = iconNameToSVG( icon.iconName );

	return (
		<div { ...blockProps }>
			<div className="alpha-icon-wrapper">
				<span className="alpha-icon">{ IconComponent }</span>
			</div>
		</div>
	);
}
